import { createFileRoute } from "@tanstack/react-router";

import BillingPage from "@/features/dashboard/pages/billing";

export const Route = createFileRoute("/(app)/dashboard/settings/billing")({
  component: () => (
    <main role="main" aria-label="Plan and billing" className="min-h-screen w-full">
      <BillingPage />
    </main>
  ),
  errorComponent: ({ error }: { error: Error }) => (
    <div role="alert" className="flex min-h-screen items-center justify-center p-4">
      <div className="text-center">
        <h1 className="text-2xl font-bold">Error Loading Billing</h1>
        <pre className="mt-4">{error.message}</pre>
      </div>
    </div>
  ),
});
